import React from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useTheme } from "./ThemeContext";
import map from './imeges/map.gif'

const JoinOurTeam = () => {

    const { theme } = useTheme();
  
  return (
    <div id='contact' style={{ backgroundColor: theme === "dark" ? "#1e1e1e" : "",width: '100%', paddingBottom: '0' }}>
      {/* Join Our Team Section */}
      <section className="text-center pt-5 pb-0">
        <h2 className="fw-bold">Join Our Team.</h2>
        <p>Realize your potential.</p>
        <button className="btn btn-outline-light px-4" style={{ backgroundColor: '#001351' }}>Explore Careers</button>
     
        </section>
      {/* Contact Us Section */}
      <section className=" text-center pt-5 pb-0" >
        <h2 className="fw-bold  ">Contact Us.</h2>
       

        <div className="container-fluid"> {/* Changed to container-fluid to prevent Bootstrap margins */}
          <div className="row row-cols-1 row-cols-md-3 g-4">
            {/* Call Us */}
            <div className="col">
              <div className="card text-dark shadow-sm d-flex align-items-center justify-content-center"
                style={{ borderRadius: "30px", minHeight: "150px", border: '4px solid #32afb5', height: '100%' }}>
                <i className="bi bi-telephone-inbound fs-3 mb-2"></i>
                                <h5 className="mt-3">Reach Us:</h5>

                {/* <h5 className="mt-3">Call Us:</h5> */}
             
             
             <div className="d-flex align-items-center ms-2">
              <span className=" px-2 py-1 me-2 d-inline-block">
                <i className="bi bi-envelope fs-5"></i>
              </span>
              <p className="mb-0">aragothaman@botbridgetech.com</p>
         </div>
   
                   <div className="d-flex align-items-center me-5">
              <span className=" px-2 py-1 me-2 d-inline-block">
                <i className="bi bi-telephone-inbound fs-5"></i>
              </span>
              <p className="mb-0">+91 9444617577</p>
         </div>

                {/* <p className="mb-0">+91 9444617577</p> */}
                 {/* Removed extra margin */}
                {/* <h5 className="mt-3">Email Us:</h5> */}
              </div>
            </div>
            

             {/* Address */}
            <div className="col">
              <div className="card text-dark p-3 shadow-sm d-flex align-items-center justify-content-center"
                style={{ borderRadius: "30px", minHeight: "150px", border: '4px solid #32afb5', height: '100%' }}>
                <i className="bi bi-geo-alt fs-3"></i>
                <h5 className="mt-3">Registered Office:</h5>
                <p className="text-center mb-0">
                  #2, Bharathiyar Street, <br />
                  Hindustan Lever Colony, Pammal<br />
                  Chennai-600075
                </p>
              </div>
            </div>


            {/* Development Office*/}
            <div className="col location-card">
  <a
 href="https://www.google.com/maps?q=12.94110834253714,80.14789460181387&zoom=15"    
//  href="https://www.google.com/maps/dir/?api=1&destination=12.94110834253714,80.14789460181387"
 target="_blank" // Opens in a new tab
    rel="noopener noreferrer" // Security feature for opening links in a new tab
    className="text-decoration-none"
  >
    <div className="card text-dark p-3 shadow-sm d-flex align-items-center justify-content-center"
      style={{ borderRadius: "30px", minHeight: "150px", border: '4px solid #32afb5', height: '100%' }}>
      {/* <i className="bi bi-geo-alt fs-3 location-icon"></i> */}
     <img src={map} alt="Location Map" className="img-fluid" style={{ width: "50px", height: "50px" }} />
      <h5 className="mt-3">Development Center:</h5>
      <p className="text-center mb-0">
        #35A, Dr Rajendra Prasad Road, <br />
        Hasthinapuram, Chitlapakkam <br />
        Chennai-600044
      </p>
    </div>
  </a>
</div>


           
          </div>
        </div>

        {/* Last paragraph - Removed bottom margin */}
        <p className="mt-4  mb-0 pb-0">If You Have Any Query, Feel Free To Contact Us</p>
      </section>
    </div>
  );
};

export default JoinOurTeam;
